export function chunk<T>(array: Array<T>, size: number): Array<Array<T>> {
    const chunks: Array<Array<T>> = [];
    const tmp: Array<T> = [...array];

    if (size <= 0) {
        return chunks;
    }

    while (tmp.length) {
        chunks.push(tmp.splice(0, size));
    }

    return chunks;
}
